var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokFooterHomeInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9345_2003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9163 11.992V23.0098C24.9163 23.5156 24.7071 24.0006 24.3346 24.3582C23.9621 24.7158 23.457 24.9167 22.9302 24.9167H17.9649C17.4382 24.9167 16.933 24.7158 16.5605 24.3582C16.1881 24.0006 15.9788 23.5156 15.9788 23.0098V18.2428C15.9788 17.9899 15.8742 17.7474 15.688 17.5686C15.5017 17.3898 15.2491 17.2894 14.9858 17.2894H11.0136C10.7502 17.2894 10.4976 17.3898 10.3114 17.5686C10.1251 17.7474 10.0205 17.9899 10.0205 18.2428V23.0098C10.0205 23.5156 9.81125 24.0006 9.43878 24.3582C9.06631 24.7158 8.56114 24.9167 8.03439 24.9167H3.06912C2.54237 24.9167 2.03719 24.7158 1.66473 24.3582C1.29226 24.0006 1.08301 23.5156 1.08301 23.0098V11.992C1.08297 11.728 1.13998 11.467 1.25045 11.2253C1.36092 10.9837 1.52243 10.7667 1.72477 10.5881L11.6553 1.59259L11.669 1.57948C12.0346 1.26024 12.511 1.08334 13.0052 1.08334C13.4995 1.08334 13.9759 1.26024 14.3415 1.57948C14.3458 1.58414 14.3503 1.58852 14.3552 1.59259L24.2857 10.5881C24.486 10.7676 24.6455 10.9851 24.754 11.2267C24.8625 11.4683 24.9178 11.7288 24.9163 11.992Z",
    stroke: "white",
    strokeWidth: 2.16667
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9345_2003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokFooterHomeInactive);
export default __webpack_public_path__ + "static/media/tiktok_footer_home_inactive.87aeb605f41bb0595a7778b221a11c28.svg";
export { ForwardRef as ReactComponent };